import { useEffect, useState } from 'react';
import useMenus from '../context/MenuContext';
import useParam from '../context/ParamContext';
import useUsers from '../context/UsersContext';

export const useProjectTasks = () => {
  const { menus, getMenus, getMenuSubMenuId, getCanEdit } = useMenus();
  const { getParam } = useParam();
  const { getUser, user } = useUsers();

  const [refetchTable, setRefetchTable] = useState(false);
  const [viewField, setViewField] = useState(true);
  const [selectedValues, setSelectedValues] = useState({});
  const [operatorsDisabled, setOperatorsDisabled] = useState(false);
  // This submenu is used for type/status (simpleTask), while permissions come from projectTasks
  const [submenu, setSubmenu] = useState(null);
  const [projectTaskSubmenu, setProjectTaskSubmenu] = useState(null);
  const [canEdit, setCanEdit] = useState(true);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [autocompleteData, setAutocompleteData] = useState({});
  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    project: [],
    user: [],
    userGroup: [],
    type: [],
    status: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMenus();
    getParam();
    if (!Object.keys(user || {}).length) getUser();
  }, []);

  useEffect(() => {
    const projectTasksSubmenuId = getMenuSubMenuId('projectTasks');
    const simpleTasksubmenuId = getMenuSubMenuId('simpleTask');
    setSubmenu(simpleTasksubmenuId);
    setCanEdit(getCanEdit(projectTasksSubmenuId));
    setProjectTaskSubmenu(projectTasksSubmenuId);
  }, [menus]);

  return {
    refetchTable,
    setRefetchTable,
    viewField,
    setViewField,
    selectedValues,
    setSelectedValues,
    operatorsDisabled,
    setOperatorsDisabled,
    submenu,
    canEdit,
    rowSelectionModel,
    setRowSelectionModel,
    autocompleteData,
    setAutocompleteData,
    autocompleteOptions,
    setAutoCompleteOptions,
    loading,
    setLoading,
    projectTaskSubmenu,
  };
};

export default useProjectTasks;
